{
  "accessControl.delete.confirmation": "<1>{{ value }}</1> er slettet fra Tilgangstyring.",
  "accessControl": "Tilgangsstyring",
  "memberFee.add": "Legg til kontingent",
  "addFromResourceBase": "Legg til fra ressursbasen",
  "addNew": "Legg til ny",
  "addToBoard": "Legg til i styret",
  "addUser": "Legg til bruker",
  "clusterMemberAdvisor.title": "Rådgivere",
  "focusArea.details.subtitle": "Alle prosjekter og aktiviteter tilknyttet til fokusområde er listet under.",
  "mainGoal.details.subtitle": "Alle prosjekter og aktiviteter tilknyttet til hovedmålet er listet under.",
  "projectCategory.details.description.1": "Alle prosjekter og aktiviter tilknyttet til prosjektkategorien er listet under.",
  "memberFee.amount": "Beløp (kr)",
  "eMailInviteWillBeSent": "En e-post med invitasjon blir sendt til denne brukeren.",
  "projectCategory.delete.confirm": "Er du sikker på at du vil slette {{ name }}?",
  "accessControl.delete.modal.title": "Er du sikker på at du vil slette disse brukerne?",
  "deleteInterestAreaMessage": "Er du sikker på at du vil slette dette interesseområdet?",
  "memberFee.delete.title": "Er du sikker på at du vil slette denne kontingenten?",
  "timeRate.delete.confirmation": "Er du sikker på at du vil slette denne timesatsen?",
  "timeRate.description": "Øverst vises beløpet for standard timesats. Denne timesatsen vil gjelde for alle kontaktene som finnes i klyngen - med mindre man har definert en egendefinert timesats for kontakten (demonstreres senere i brukerveiledningen)",
  "clusterBoardMember.title": "Styringsgruppe",
  "changeRole": "Endre rolle",
  "changeRoleFor": "Endre rolle for",
  "chooseRole": "Velg rolle",
  "coreData": "Grunndata",
  "addUser.error": "Kunne ikke opprette denne brukeren.",
  "interestArea.error.edit": "Kunne ikke endre interesseområde. Prøv igjen.",
  "error.mainContact.update": "Kunne ikke endre hovedkontakt. Vennligst prøv igjen.",
  "error.interestArea.create": "Kunne ikke lage nytt interesseområde. Vennligst prøv igjen.",
  "timeRate.create.error": "Kunne ikke opprette timesats. Vennligst prøv igjen.",
  "error.interestArea.delete": "Kunne ikke slette interesseområde. Vennligst prøv igjen.",
  "interestArea.error.delete": "Kunne ikke slette interesseområde. Prøv igjen.",
  "projectCategory.error.delete": "Kunne ikke slette prosjektkategori. Vennligst prøv igjen.",
  "accessControl.delete.error": "Kunne ikke slette brukerne, vennligst prøv igjen.",
  "timeRate.delete.error": "Kunne ikke slette timesats. Vennligst prøv igjen.",
  "interestArea.error.save": "Kunne ikke lagre interesseområde. Prøv igjen.",
  "error.interestArea.update": "Kunne ikke oppdatere interesseområde. Vennligst prøv igjen.",
  "projectCategory.error.edit": "Kunne ikke oppdatere prosjektkategori. Sjekk at samme navn ikke allerede eksisterer og prøv på nytt.",
  "timeRate.update.error": "Kunne ikke endre timesats. Vennligst prøv igjen.",
  "projectCategory.delete": "Slett prosjektkategori",
  "portalInvitation.modal.description": "Vil du sende portalinvitasjon til disse kontaktene?",
  "editDefaultTimeRate": "Endre standard timesats",
  "editInterestAreas": "Endre interesseområde",
  "memberFee.edit": "Endre medlemskontingent",
  "projectCategory.edit": "Endre prosjektkategori",
  "editTimeRate": "Endre timesats",
  "employees": "Ansatte",
  "external": "Ekstern",
  "focusArea.notFound": "Fokusområdet ikke funnet",
  "memberFee.delete.description": "Hvis du sletter denne kontingenten vil alle medlemmer som er knyttet til kontingenten miste sin kontingent.",
  "timeRate.delete.description": "Hvis du sletter denne satsen så vil alle kontakter som er knyttet til denne satsen bli knyttet til standard sats.",
  "interestAreas": "Interesseområder",
  "clusterManagement.title": "Ledelse",
  "memberFee": "Medlemskontingent",
  "mission": "Misjon",
  "memberFee.name": "Navn på kontingent",
  "memberFee.new": "Ny medlemskontingent",
  "memberFee.delete.noMembers": "Ingen medlemmer er knyttet til denne kontingenten.",
  "otherTimeRates": "Andre timesatser",
  "clusterManagement.description": "Vennligst legg til alle kontaktpersoner som utgjør ledelsen.",
  "portalInvitation.success": "Portalinvitasjoner sendt!",
  "project": "prosjekt",
  "projectCategories": "Prosjektkategorier",
  "projectCategory.details.title": "Prosjektkategoriens prosjekter og aktiviteter",
  "projectCategory": "Prosjektkategori",
  "projectCategory.details.description.2": "Prosjektkategorien kan ikke slettes hvis prosjekter bruker den.",
  "projectCategory.notFound": "Prosjektkategori ikke funnet",
  "project_plural": "prosjekter",
  "removeFromManagement": "Fjern fra ledelse",
  "searchByNameEmailOrRole": "Søk etter navn, e-post eller rolle",
  "selectRole": "Velg rolle",
  "sendInvite": "Send invitasjon",
  "sendPortalInvitation": "Send portalinvitasjon",
  "portalInvitation.pending": "Sender portalinvitasjoner...",
  "memberFee.description": "Sett opp et antall medlemskontingenter som passer til måten dere organiserer medlemmene. Du kan sette en medlemskontingent på hvert medlem eller sette et egendefinert beløp.",
  "focusArea.details.title": "Fokusområdets prosjekter og aktiviteter",
  "mainGoal.details.title": "Hovedmålets prosjekter og aktiviteter",
  "memberFee.delete.members": "Det er {{ count }} medlemmer knyttet til denne kontingenten.",
  "fieldRequired": "Dette feltet er påkrevd",
  "accessControl.delete.text": "Dette vil slette <1>{{ value }}</1> fra Tilgangstyring. Vedkommende vil miste tilgang til Flerbedriftsportalen. Du kan ikke angre denne handlingen.",
  "timeRates": "Timesatser",
  "memberFee.tips": "Tips: Legg til beløp i navnet på denne kontingenten for å få en rask oversikt over navn og beløp når du knytter medlemmene mot kontingenten",
  "vision": "Visjon",
  "visionMission.title": "Visjon og misjon",
  "yourProfile.title": "Profilen din",
  "accessControl.invite.error": "Kunne ikke invitere brukere. Vennligst prøv igjen.",
  "accessControl.createUser.title.selectMethod": "Velg hvordan du vil legge til ny bruker",
  "accessControl.createUser.title.searchExistingContact": "Hent informasjon fra en kontakt",
  "accessControl.createUser.title.createNewUser": "Legg til ny bruker",
  "accessControl.createUser.confirmation.text": "<1>{{ name }}</1> er lagt til.",
  "accessControl.createUser.create.error.message": "Kunne ikke opprette bruker. Vennligst prøv igjen.",
  "accessControl.createUser.invite.error.message": "Kunne ikke invitere bruker. Vennligst prøv igjen.",
  "accessControl.inviteUser.confirmation.text": "E-poster med invitasjon er sendt ut til disse brukerne.",
  "accessControl.deleteUsers.text": "Disse brukerne er slettet fra Tilgangstyring",
  "accessControl.delete.error.modal.title": "Beklager, vi klarer ikke å slette disse brukerne",
  "accessControl.delete.error.modal.description": "Disse brukerne er desverre ikke blitt slettet fra Tilgangstyring",
  "accessControl.delete.error.modal.supportText": "Prøv gjerne å sjekke om de allerede er slettet fra Tilgangstyring, eller kontakt oss på <1>{{ email }}</1>",
  "accessControl.create.cluster.radio.label": "Har du en registrert kontakt du ønsker å gi tilgang til Flerbedriftsportalen?",
  "accessControl.create.cluster.radio.value.existing": "Ja, jeg vil hente informasjonen fra en kontakt i Ressursbasen",
  "accessControl.create.cluster.radio.value.new": "Nei, jeg vil legge til en ny bruker",
  "accessControl.create.cluster.radio.error": "Du må velge minst én måte å legge til ny bruker",
  "accessControl.selectAccessType": "Velg tilgangstype",
  "accessControl.roles.internal.writeAccess": "Ansatt - skrivetilgang",
  "accessControl.roles.external.readAccess": "Ekstern - lesetilgang",
  "accessControl.roles.select.helpText": "Alle ansatte får skrivetilgang, men kun administrator kan legge til nye brukere. Eksterne brukere får kun lesetilgang, og de kan ikke gjøre endringer i portalen.",
  "accessControl.roles.select.label": "Tilgangstype",
  "accessControl.edit.modal.title.default": "Rediger brukerinformasjon",
  "accessControl.edit.modal.title.error": "Beklager, vi klarte ikke å endre denne brukeren",
  "accessControl.edit.modal.confirmation.text": "Informasjonen til <1>{{ name }}</1> er oppdatert.",
  "accessControl.edit.modal.error.supportText": "Prøv gjerne å laste inn siden på nytt, og forsøk å endre kontakten på nytt, eller kontakt oss på <1>{{ email }}</1>",
  "accessControl.edit.modal.error.text": "Det oppstod en feil ved oppdatering av <1>{{ name }}</1>. Vennligst prøv igjen.",
  "emailSettings": "E-postvarsler",
  "emailSettings.updateOk": "Innstillingene for e-postvarsler er oppdatert",
  "emailSettings.updateFailed": "Kunne ikke oppdatere innstillingene for e-postvarsler.",
  "emailSettings.frequency": "Frekvens",
  "emailsettings.activity": "Aktivitet",
  "emailSettings.opportunities": "Nye henvendelser"
}
